import { render, staticRenderFns } from "./PlanningSettingsScope.vue?vue&type=template&id=8b1a9b18&scoped=true"
import script from "./PlanningSettingsScope.vue?vue&type=script&lang=js"
export * from "./PlanningSettingsScope.vue?vue&type=script&lang=js"
import style0 from "./PlanningSettingsScope.vue?vue&type=style&index=0&id=8b1a9b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1a9b18",
  null
  
)

export default component.exports